import styled from 'styled-components'

export const Root = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-gap: 5px;
	margin: 15px;
	min-height: 200px;

	@media (max-width: 1000px) {
		grid-template-columns: 1fr;
	}
`

export const EditorSectionRoot = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	margin: 10px;
	border: 1px solid #dcdada;
	border-radius: 5px;
	box-shadow: 0 0 4px #0000001a;
	padding: 0;
`

export const EditorSectionCaption = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	border-bottom: 1px solid #dcdada;
	border-radius: 5px 5px 0 0;
	padding: 5px 10px;
	width: 100%;
	font-weight: 700;
`

export const EditorSectionBody = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	padding: 10px;
	width: 100%;
`

export const EditorSectionContentRow = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`

export const EditorSectionPreviewContentRow = styled.div`
	display: grid;
	grid-template-columns: 70px 1fr;
`

type TPreviewContainerProps = {
	image: string
}

export const PreviewContainer = styled.div`
	border: 1px solid #dcdada;
	border-radius: 5px;
	background-image: url('${(props: TPreviewContainerProps) => props.image}');
	background-position: center;
	background-repeat: no-repeat;
	background-size: contain;
`

type TRowContentLineProps = {
	count: number
}

export const EditorSectionRowContentLine = styled.div`
	display: grid;
	grid-template-columns: repeat(${(props: TRowContentLineProps) => props.count}, 1fr);
	gap: 15px;

	@media (max-width: 1641px) {
		grid-template-columns: 1fr;
	}
`

export const TypeInfo = styled.p`
	padding-left: 5px;
	color: rgba(0, 0, 0, 0.6);
	font-size: 17px;

	& span {
		color: black;
	}
`

type TTrashInfoProps = {
	trash: boolean | number
}

export const TrashInfo = styled.p`
	padding-left: 5px;
	color: ${(props: TTrashInfoProps) => (props.trash ? 'red' : 'Green')};
	font-size: 17px;
`
